import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Auth from '@aws-amplify/auth';
import atatus from 'atatus';
import { TOO_MANY_REQUEST_EXCEPTION, UNEXPECTED_ERROR } from 'constant/index';
import useAuth from 'context/useAuth';
import useFormFields from 'hooks/useFormFields';
import PropTypes from 'prop-types';

import AccountVerification from 'components/account/AccountVerification';
import accountVerificationErrors from 'components/errors/account/accountVerificationErrors';
import ErrorView from 'components/errors/ErrorView';
import FocusableHeader from 'components/focusableheader/FocusableHeader';
import OverlaySpinner from 'components/spinner/OverlaySpinner';

const AccountVerificationPage = (props) => {
    const { formFields, setFormField } = useFormFields({
        verificationCode: '',
    });
    const { verificationCode } = formFields;
    const { handleSuccessfullLogin, userMFASession } = useAuth();

    const [isFetchingUser, setFetchingStatus] = useState(false);
    const [error, setError] = useState(null);
    const [email] = useState(null);

    useEffect(() => {
        performance.measure('MFA-triggered', 'login');
        const [{ duration }] = performance.getEntriesByName('MFA-triggered', 'measure');
        atatus.recordTransaction('MFA-triggered', duration);
    }, []);

    const handleVerificationCode = async ({ verificationCode }) => {
        atatus.startTransaction('MFA-verification');
        setFetchingStatus(true);
        setError(null);
        try {
            const authenticatedUser = await Auth.sendCustomChallengeAnswer(userMFASession, verificationCode);
            setFetchingStatus(false);
            if (authenticatedUser.challengeParam && !authenticatedUser.challengeParam.errorCode) {
                throw new Error('IncorrectOTP');
            }
            if (
                authenticatedUser.challengeParam &&
                authenticatedUser.challengeParam.errorCode === TOO_MANY_REQUEST_EXCEPTION
            ) {
                throw new Error('AttemptLimitExceeded');
            }
            if (authenticatedUser.challengeParam && authenticatedUser.challengeParam.errorCode === UNEXPECTED_ERROR) {
                throw new Error('UnexpectedErrorOccured');
            }
            if (authenticatedUser.signInUserSession) {
                atatus.endTransaction('MFA-verification');
                handleSuccessfullLogin(authenticatedUser, true);
            }
        } catch (e) {
            atatus.failTransaction('MFA-verification');
            setFetchingStatus(false);
            const errorMessage = accountVerificationErrors[e.message];
            setError(errorMessage);
        }
    };

    return (
        <React.Fragment>
            {isFetchingUser && (
                <OverlaySpinner>
                    <p>
                        <FormattedMessage id="spinner.message.2" />
                    </p>
                </OverlaySpinner>
            )}
            <div className="account-verification-page grey-banner">
                <div className="account-verification-header">
                    <FocusableHeader>
                        <FormattedMessage id="pages.account.verification.heading" />
                    </FocusableHeader>
                    <hr className="fs-bar orange" />
                </div>

                <div className="account-verification-content box-wrapper">
                    <ErrorView error={error} />
                    <AccountVerification
                        email={email}
                        onSubmit={handleVerificationCode}
                        password={props.password}
                        setError={setError}
                        setFetchingStatus={setFetchingStatus}
                        setFormField={setFormField}
                        username={props.username}
                        verificationCode={verificationCode}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

AccountVerificationPage.propTypes = {
    password: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    username: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
};

export default AccountVerificationPage;
